export const BaseColors = {
	BLUE: 'blue',
	INDIGO: 'indigo',
	CYAN: 'cyan',
	TEAL: 'teal',
	EMERALD: 'emerald',
	GREEN: 'green',
	DARKGREEN: 'darkgreen',
	LIME: 'lime',
	YELLOW: 'yellow',
	AMBER: 'amber',
	ORANGE: 'orange',
	RED: 'red',
	ROSE: 'rose',
	PINK: 'pink',
	MAGENTA: 'magenta',
	PURPLE: 'purple',
	STONE: 'stone',
	GRAY: 'gray',
	SLATE: 'slate',
	DARK: 'dark',
	LIGHT: 'light',
};

export type BaseColors = (typeof BaseColors)[keyof typeof BaseColors];

export const TokenColors = {
	PRIMARY: 'primary',
	SECONDARY: 'secondary',
	TERTIARY: 'tertiary',
	SUCCESS: 'success',
	DANGER: 'danger',
	WARNING: 'warning',
	ERROR: 'error',
	INFO: 'info',
	LIGHT: 'light',
	DARK: 'dark',
	BACKGROUND: 'background',
	FOREGROUND: 'foreground',
};

export type TokenColors = (typeof TokenColors)[keyof typeof TokenColors];

export const Color = { ...BaseColors, ...TokenColors };

export type Color = (typeof Color)[keyof typeof Color];
